import type { NativeGlassStatus } from "./native-glass-types";

export const NATIVE_GLASS_FALLBACK_SETTLED =
  "denker:native-glass-fallback-settled";
export const FALLBACK_NATIVE_GLASS_STATUS: NativeGlassStatus = {
  mode: "unsupported",
  surfaceCount: 0,
};

export function clearNativeGlassFallback(): void {
  delete document.documentElement.dataset.desktopNativeGlassFallback;
}

export function settleNativeGlassFallback(traceId?: string | null): void {
  document.documentElement.dataset.desktopNativeGlassFallback = "true";
  window.dispatchEvent(
    new CustomEvent(NATIVE_GLASS_FALLBACK_SETTLED, { detail: { traceId } }),
  );
}
